import request from '@/server/request';
import { API_JAVA3, API_JAVA, API_SYS, API_FDD } from '@/utils/base';
import axios from 'axios';

// 内容管理
export async function informationList (params) {
  return request(API_JAVA3 + '/farm/information/list', {
    method: 'GET',
    params: params
  });
}

export async function informationdetail (params) {
  return request(API_JAVA3 + '/farm/information/detail', {
    method: 'GET',
    params: params
  });
}

// 价格,行情,数据
export async function contentManagelist (params) {
  return request(API_JAVA + '/tmr/contentManage/list', {
    method: 'GET',
    params: params
  });
}

// 内容类型 0-价格 1-行情 2-资讯 3-数据 4-研究报告

export async function getmsglist (params) {
  return request(API_JAVA + '/tmr/contentManage/list', {
    method: 'GET',
    params: params
  });
}

// 行情
export async function tmrcontentManagelist (id, params) {
  return request(API_JAVA + `/tmr/contentManage/${id}`, {
    method: 'GET',
    params: params
  });
}

//经纪人
export async function brokerlist (params) {
  return request(API_JAVA + '/tmr/broker/list', {
    method: 'GET',
    params: params
  });
}

//供求信息   dataType: 0-供应 1-求购'
export async function supplyanddemandlist (params) {
  return request(API_JAVA + '/tmr/supplyAndDemand/list', {
    method: 'GET',
    params: params
  });
}

// 电商网站注册接口
export async function createuser (params) {
  console.log(params);
  return request(API_SYS + '/sys/auth/jgw/register', {
    method: 'POST',
    data: params
  });
}

// 确定上传报价
export async function batchImportQuotation (params) {
  return request(API_JAVA + '/jgw/jgwProduct/mall/batchImportQuotation', {
    method: 'POST',
    data: params
  });
}

// 导出报价
export async function newbatchExportQuotation (params) {
  return axios({
    method: 'POST',
    url: API_JAVA + '/jgw/jgwProduct/mall/batchExportQuotation',
    responseType: 'blob', //告诉服务器需要的响应格式
    data: params,
    // headers: {
    //   // 配置请求头，若统一处理可省略
    //   Accept: 'application/octet-stream'
    // }
  })
    .then(response => {
      let blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel' // 将会被放入到 blob 中的数组内容的 MIME 类型,常用 ：application/vnd.ms-excel
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // link.download = params.fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    });
}

// 赊销额度查询
export async function jgwCreditList (params) {
  return request(API_JAVA + '/erp/credit/list', {
    method: 'POST',
    data: params
  });
}

// 变更赊销额度
export async function jgwCreditUpdate (params) {
  return request(API_JAVA + `/erp/credit/update/${params.userId}/${params.changeCredit}`, {
    method: 'POST',
    data: params
  });
}

// 变更赊销额度
export async function jgwCreditRecord (params) {
  return request(API_JAVA + `/erp/credit/record/list/${params.userId}`, {
    method: 'POST',
    data: params
  });
}

// 赊销额度提升
export async function jgwCreditApplyList (params) {
  return request(API_JAVA + `/erp/credit/apply/list`, {
    method: 'POST',
    data: params
  });
}

// 赊销额度提升详情
export async function jgwCreditApplyDetail (params) {
  return request(API_JAVA + `/erp/credit/apply/detail/${params.applyRecordId}`, {
    method: 'POST',
    data: params
  });
}

// 赊销额度提升详情保存按钮
export async function jgwCreditAudit (params) {
  return request(API_JAVA + `/erp/credit/audit`, {
    method: 'POST',
    data: params
  });
}

// 额度申请导出
export async function creditApplyExport (params) {
  return axios({
    method: 'POST',
    url: API_JAVA + '/erp/credit/apply/export',
    responseType: 'blob', //告诉服务器需要的响应格式
    data: params,
    // headers: {
    //   // 配置请求头，若统一处理可省略
    //   Accept: 'application/octet-stream'
    // }
  })
    .then(response => {
      let blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel' // 将会被放入到 blob 中的数组内容的 MIME 类型,常用 ：application/vnd.ms-excel
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      // link.download = params.fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    });
}

// 赊销订单列表
export async function jgwOrderList (params) {
  return request(API_JAVA + `/erp/order/list`, {
    method: 'POST',
    data: params
  });
}

// 赊销订单详情
export async function jgwOrderDetail (params) {
  return request(API_JAVA + `/erp/order/detail/${params.orderId}`, {
    method: 'POST',
    data: params
  });
}

// 普通确认赊销弹窗确认按钮
export async function jgwOrderConfirm (params) {
  return request(API_JAVA + `/erp/credit/order/confirm/${params.orderId}`, {
    method: 'POST',
    data: params
  });
}

// 表单确认赊销弹窗确认按钮
export async function jgwOrderConfirmTaking (params) {
  return request(API_JAVA + `/erp/order/taking`, {
    method: 'POST',
    data: params
  });
}

// 录入收款信息
export async function jgwReceiptAdd (params) {
  return request(API_JAVA + `/jgw/Receipt/add`, {
    method: 'POST',
    data: params
  });
}

// 录入发货信息
export async function jgwOrderSendGoods (params) {
  return request(API_JAVA + `/erp/order/send/goods`, {
    method: 'POST',
    data: params
  });
}

// 编辑发货信息
export async function jgwOrderUpdateSendInfo (params) {
  return request(API_JAVA + `/erp/order/update/sendInfo/${params.id}`, {
    method: 'POST',
    data: params
  });
}

// 删除发货信息
export async function jgwOrderDeleteSendInfo (params) {
  return request(API_JAVA + `/erp/order/delete/sendInfo/${params.id}`, {
    method: 'POST',
    data: params
  });
}

// 合同列表
export async function jgwContractListBack (params) {
  return request(API_JAVA + `/jgw/contract/list`, {
    method: 'POST',
    data: params
  });
}

// 法大大签约
export async function jgwContractErpSign (params) {
  return request(API_JAVA + `/jgw/contract/erpSign`, {
    method: 'GET',
    params: params
  });
}

// 赊销天数配置
export async function creditConfig (params) {
  return request(API_JAVA + `/credit/config`, {
    method: 'GET',
    params: params
  });
}

// 确认赊销还款
export async function creditOrderReceipt (params) {
  return request(API_JAVA + `/erp/credit/order/receipt`, {
    method: 'POST',
    data: params
  });
}

// 签合同前调用此接口
export async function fillContract (params) {
  return request(API_JAVA + `/jgw/jgwOrder/fill/contract/${params.orderId}`, {
    method: 'POST',
    data: params
  });
}

// 确认并生成电子签章
export async function contractSign (params) {
  return request(API_FDD + `/fadada/contract/jgw/sign`, {
    method: 'GET',
    params: params
  });
}

// 确认收货
export async function jgwOrderConfirmReceive (params) {
  return request(API_JAVA + `/jgw/jgwOrder/confirm/receive/${params.orderId}`, {
    method: 'POST',
    params: params
  });
}

// 认证公司查询
export async function getVersionSecOrderSearchCompany (params) {
  return request(API_JAVA + `/companies/list`, {
    method: 'GET',
    params: params
  });
}

// 认证公司查询detail接口
export async function companiesManageDetail (params) {
  return request(API_JAVA + `/companies/manage/detail/${params.id}`, {
    method: 'GET'
  });
}

// 加入公司
export async function companiesUserAdd (params) {
  return request(API_JAVA + `/companies/user/add`, {
    method: 'POST',
    data: params
  });
}

// 埋点
export async function browsingAdd (params) {
  return request(API_JAVA + `/jgw/browsing/add`, {
    method: 'POST',
    data: params
  });
}

// 放弃认证
export async function userGiveUp (params) {
  return request(API_JAVA + `/companies/user/give_up`, {
    method: 'POST',
    data: params
  });
}

// 认证二合一
export async function companiesAddTwoAndOne (params) {
  return request(API_JAVA + `/companies/add`, {
    method: 'POST',
    data: params
  });
}

// 企业更新
export async function companiesUpdate (params) {
  return request(API_JAVA + `/companies/update/${params.id}`, {
    method: 'POST',
    data: params
  });
}

// 上传签收单
export async function erpOrderUploadReceipt (params) {
  return request(API_JAVA + `/erp/order/upload/receipt`, {
    method: 'POST',
    data: params
  });
}

// 表单确认赊销弹窗确认按钮---自动签章接口
export async function jgwErpOrderAutoSign (orderId) {
  return request(API_JAVA + `/erp/order/autoSign/${orderId}`, {
    method: 'POST',
  });
}

// 订单详情--更新运单
export async function orderRefreshDelivery (params) {
  return request(API_JAVA + `/erp/order/refresh/delivery?orderId=${params.orderId}`, {
    method: 'POST'
  });
}

// 订单详情--取消派单
export async function orderCancelDelivery (params) {
  return request(API_JAVA + `/erp/order/cancel/delivery?orderId=${params.orderId}`, {
    method: 'POST',
    data: params
  });
}

// 订单详情--在线派单
export async function orderOnlineDelivery (params) {
  return request(API_JAVA + `/erp/order/online/delivery`, {
    method: 'POST',
    data: params
  });
}

// 订单详情--物流信息
export async function orderLogisticInfo (params) {
  return request(API_JAVA + `/erp/order/logistic/info`, {
    method: 'GET',
    params: params
  });
}

// 订单详情--订单金额
export async function orderDepositInfo (params) {
  return request(API_JAVA + `/erp/order/deposit/info`, {
    method: 'GET',
    params: params
  });
}

// 订单详情--确认订单
export async function orderConfirmDelivery (params) {
  return request(API_JAVA + `/erp/order/confirm/delivery?orderId=${params.orderId}`, {
    method: 'POST'
  });
}

// 订单详情--关闭派单
export async function orderCloseDelivery (params) {
  return request(API_JAVA + `/erp/order/close/delivery?orderId=${params.orderId}`, {
    method: 'POST'
  });
}

// 特价商品列表
export async function bargainList (params) {
  return request(API_JAVA + `/jgw/jgwProduct/bargain/list`, {
    method: 'GET',
    params: params
  });
}

/**
 *  现货指数
 */
export const getSpotIndexList = (params) => {
  return request(API_JAVA + '/tmr/index/spot/index/list', {
    method: 'GET',
    params: params
  })
}

/**
 *  指数地图
 */
export const getSpotMap = (params) => {
  return request(API_JAVA + '/tmr/index/index/map', {
    method: 'GET',
    params: params
  })
}
/**
 *  价格均价
 */
export const getAvgPrice = (params) => {
  return request(API_JAVA + '/tmr/index/avg/price', {
    method: 'GET',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/content.js